export default __webpack_public_path__ + "static/media/gerencia.f1b5b678.png";